import * as Utils from './utils';

const body = document.body,
      siteUrl = document.location.origin,
      filterList = document.querySelector("ul.filters"),
      categoryButton = document.querySelectorAll(".js-filter-posts"),
      shopItems = document.querySelectorAll(".shop-item__container"),
      postContainer = document.querySelector(".js-post-container");

let postRows = 4;

function loadMorePosts() {
  let numPosts = (postRows%2 == 0) ? 3 : 4;

  let hiddenPosts = postContainer.querySelectorAll(".hidden");

  for (var i = 0; i < numPosts; i++) {
    // Check post exists, in case there is less than 3 or 4
    if(typeof hiddenPosts[i] !== "undefined") {
      hiddenPosts[i].classList.add('delay-'+i);
      hiddenPosts[i].classList.remove('hidden');
    } else {
      // If we have an incomplete row, hide button
      toggleLoadButton('hide');
    }
  }

  // Check whether there's any remaining elements
  hiddenPosts = postContainer.querySelectorAll(".hidden");
  if(hiddenPosts.length == 0) {
    toggleLoadButton('hide');
  }

  postRows++;
}

function changeCategory(e) {
  e.preventDefault();

  var el = e.target;
  var tag = el.classList.contains('active') ? '' : el.dataset.tag;

  // let ajaxUrl = siteUrl + '/wp-admin/admin-ajax.php';

  postContainer.classList.add('loading');
  resetFilterState();

  el.classList[tag == '' ? 'remove' : 'add']('active');
  filterList.classList[tag == '' ? 'remove' : 'add']('selected');


  var switchItems = function() {
  if (tag == '') {
    for (let item of shopItems) {
       item.classList.remove('hidden','in-view');
     }
  } else {
    for (let item of shopItems) {
       item.classList.remove('hidden','in-view');
     }
  const itemsToHide = document.querySelectorAll(".shop-item__container:not(." + tag + ")");
  for (let item of itemsToHide) {
	   item.classList.add('hidden');
   }
  }
  };

  var revisible = function () {
    postContainer.classList.remove('loading');
    Utils.animateInViewEls('.js-watch', 'in-view', 0.1);
    Utils.searchForImages(postContainer);
  };

  setTimeout(switchItems, 350);
  setTimeout(revisible, 350);

}

function toggleLoadButton(action) {
  loadButton.forEach(el => {
      el.classList[action == 'show' ? 'remove' : 'add']('hidden');
  });
}

function resetFilterState() {
  categoryButton.forEach(el => {
    el.classList.remove('active');
  });
}

function resetPostRows() {
  postRows = 4;
}

export function init() {

categoryButton.forEach(el => {
    el.addEventListener('click', changeCategory);
});

}
